import GraphPropertyUnitType from "./GraphPropertyUnitType";

class GraphPropertyTicks {
	constructor() {
		this.suggestedMin = 0;
		this.suggestedMax = 360;
		this.stepSize = 1;
	}
}

class GraphProperty {
	constructor(name, key, unitType = GraphPropertyUnitType.NONE, getter = null, ticks = {}, color = null) {
		this.name = name;
		this.key = key;
		this.unitType = unitType;
		this.ticks = ticks; // { suggestedMin: 0, suggestedMax: 18, stepSize: 1 };
		this.color = color;

		// Overwrite this function to use with various data structures.
		// TODO: Rethink how we do this with a software pattern.
		if (getter === null) {
			this._getter = (instance, data, index) => {
				return data[index][instance.key];
			};
		}
		else {
			this._getter = getter;
		}
	}

	getProperty(data, index) {
		return this._getter(this, data, index);
	}

	set getter(callback) {
		this._getter = callback;
	}
}
export default GraphProperty;
